interface LogoProps {
  size?: number
  className?: string
}

export function Logo({ size = 40, className = '' }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0f766e" />
          <stop offset="50%" stopColor="#14b8a6" />
          <stop offset="100%" stopColor="#2dd4bf" />
        </linearGradient>
        <radialGradient id="starGradient" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="70%" stopColor="#ccfbf1" />
          <stop offset="100%" stopColor="#5eead4" />
        </radialGradient>
        <filter id="softGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Background */}
      <rect width="100" height="100" rx="24" fill="url(#logoGradient)" />

      {/* Subtle background stars */}
      <circle cx="75" cy="28" r="1.5" fill="white" fillOpacity="0.25" />
      <circle cx="22" cy="45" r="1" fill="white" fillOpacity="0.2" />
      <circle cx="78" cy="55" r="1.2" fill="white" fillOpacity="0.2" />
      <circle cx="25" cy="75" r="1" fill="white" fillOpacity="0.25" />
      <circle cx="72" cy="78" r="1.5" fill="white" fillOpacity="0.15" />

      {/* Constellation connections - soft curves */}
      <g stroke="white" strokeWidth="1.2" strokeOpacity="0.35" strokeLinecap="round" fill="none">
        <path d="M60 22 Q52 28 45 30" />
        <path d="M45 30 Q38 35 35 42" />
        <path d="M35 42 Q40 48 48 52" />
        <path d="M48 52 Q55 55 58 60" />
        <path d="M58 60 Q52 68 48 72" />
        <path d="M48 72 Q40 76 35 80" />
      </g>

      {/* Main constellation nodes */}
      <g filter="url(#softGlow)">
        <circle cx="60" cy="22" r="6" fill="url(#starGradient)" />
        <circle cx="45" cy="30" r="4" fill="white" fillOpacity="0.9" />
        <circle cx="35" cy="42" r="5" fill="url(#starGradient)" />
        <circle cx="48" cy="52" r="7" fill="url(#starGradient)" />
        <circle cx="58" cy="60" r="4.5" fill="white" fillOpacity="0.9" />
        <circle cx="48" cy="72" r="5" fill="url(#starGradient)" />
        <circle cx="35" cy="80" r="6" fill="url(#starGradient)" />
      </g>
    </svg>
  )
}

export function LogoFull({ size = 40, className = '' }: LogoProps) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <Logo size={size} />
      <div className="flex flex-col">
        <span className="text-surface-900 font-semibold text-lg tracking-tight leading-tight">
          SecBrain
        </span>
        <span className="text-brand-600 text-[10px] font-medium tracking-wide uppercase">
          Neurodivergente
        </span>
      </div>
    </div>
  )
}

export default Logo
